import { useCurrentUser } from '@qualio/ui-components';
import { useTemplates } from '../../../../hooks/useTemplates';
import { NewDocumentButton } from '../NewDocumentButton';

export const NewDocumentButtonWrapper = () => {
  const currentUser = useCurrentUser();
  const { data: fetchedTemplates = [] } = useTemplates({
    includeArchived: false,
  });

  return (
    <NewDocumentButton currentUser={currentUser} templates={fetchedTemplates} />
  );
};
